import { render, staticRenderFns } from "./VehicleGroups.vue?vue&type=template&id=ec2cc058&"
import script from "./VehicleGroups.vue?vue&type=script&lang=js&"
export * from "./VehicleGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports